export default __webpack_public_path__ + "static/appstore-nl-c387b9e8eeea17596b61fb38ec004a1b.png";